"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZoneGeojsonCollection = void 0;
/*
 * Copyright Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const Zone_1 = require("chaire-lib-common/lib/services/zones/Zone");
const CollectionCacheable_1 = __importDefault(require("chaire-lib-common/lib/services/objects/CollectionCacheable"));
const CollectionLoadable_1 = __importDefault(require("chaire-lib-common/lib/services/objects/CollectionLoadable"));
const GenericMapObjectCollection_1 = __importDefault(require("chaire-lib-common/lib/utils/objects/GenericMapObjectCollection"));
/**
 * A collection of zones as geojson.
 *
 * TODO Consider moving to chaire-lib
 */
class ZoneGeojsonCollection extends GenericMapObjectCollection_1.default {
    constructor(features, attributes, eventManager) {
        super(features, attributes);
        this._eventManager = eventManager;
    }
    progress(progressEventName, completeRatio) {
        if (this._eventManager)
            this._eventManager.emitProgress(`${ZoneGeojsonCollection.displayName}${progressEventName}`, completeRatio);
    }
    newObject(feature, isNew = false) {
        return new Zone_1.Zone(Object.assign({}, feature.properties, { geography: feature.geometry }), isNew);
    }
    saveCache(socket) {
        return CollectionCacheable_1.default.saveCache(this, socket);
    }
    loadCache(socket) {
        return CollectionCacheable_1.default.loadCache(this, socket);
    }
    loadFromServer(socket, dataSourceId) {
        return CollectionLoadable_1.default.loadGeojsonFromServer(this, socket, 
        // FIXME Fix the `as never[]` type whent he loadGeojsonFromServer function is properly typed.
        dataSourceId !== undefined ? [dataSourceId] : []);
    }
    loadFromCollection(collection) {
        return CollectionLoadable_1.default.loadGeojsonFromCollection(this, collection);
    }
    // TODO: Consider always having the simplified version of the path in the collection and load the full path only when necessary. There may be side-effects to doing this and there may be additional properties required in the main collection. Needs some thought.
    toGeojsonSimplified() {
        const features = this.features.map(({ id, geometry, properties, type }) => ({
            type,
            id,
            geometry,
            properties: {
                shortname: properties.shortname,
                id: properties.id,
                data: properties.data
            }
        }));
        return {
            type: 'FeatureCollection',
            features
        };
    }
}
exports.ZoneGeojsonCollection = ZoneGeojsonCollection;
ZoneGeojsonCollection.displayName = 'ZoneGeojsonCollection';
ZoneGeojsonCollection.socketPrefix = 'zones';
ZoneGeojsonCollection.instanceClass = Zone_1.Zone;
exports.default = ZoneGeojsonCollection;
//# sourceMappingURL=ZoneGeojsonCollection.js.map